export const images = {
  heroImage: 'images/hero_image.png',
  notFoundImage: 'images/NotFound.png',
  notFoundImageMobile: 'images/NotFoundMobile.png',
};
